import styled from 'styled-components';

export const Title = styled.h1`
  font-family: 'Staatliches';
  color: #EB8A26;
  line-height: 60px;
  font-size: 60px;
  max-width: 500px;
  text-align: left;
  margin-left: 10px;
  @media(max-width:  900px) {
    text-align: center;
  }
`;

export const Button = styled.button`
  background: #576B7A;
  border-radius: 8px;
  font-family: 'Staatliches';
  font-size: 16px;
  color: #FFFFFF;
  letter-spacing: 0;
  text-align: center;
`;

export const IntroText = styled.p`
  font-family: 'Raleway', sans-serif;
  color: white;
  white-space: pre-wrap;
  font-weight: 400;
  max-width: 550px;
  font-size: 18px;
  line-height: 1.6;
  text-align: left;
  margin-left: 10px;
  @media(max-width:  900px) {
      text-align: left;
    }
`;

export const SolutionInput = styled.input`
  background: rgba(0,0,0,0.0);
  margin-right: 5px;
  font-size: 36px;
  color: white;
  text-align: center;
  font-weight: bold;
  width: 70px;
  height: 70px;
  outline:none;
  border-bottom: 4px solid white;
  border-top: none;
  border-right: none;
  border-left: none;

  ${({ wrongSolution }) => wrongSolution && `
  border-bottom: 4px solid red;
`}

  ${({ rightSolution }) => rightSolution && `
  border-bottom: 4px solid green;
  `}
`;

export const SubmitButton = styled.button`
  background: #576B7A;
  border-radius: 8px;
  font-size: 16px;
  color: #FFFFFF;
  letter-spacing: 0;
  text-align: center;
  margin-top: 10px;
  border: none;
  padding: 20px;
  cursor: pointer;
  border: none;
  outline:none;
`;

export const ErrorText = styled.p`
  opacity: 0;
  transition: all 0.2s ease-in;
  font-family: 'Raleway', sans-serif;
  color: red;
  font-weight: bold;
  max-width: 550px;
  font-size: 16px;
  text-align: center;
  margin: 10px;

  ${({ wrongSolution }) => wrongSolution && `
    opacity: 1;
`}
`;

export const SuccessText = styled.p`
  opacity: 0;
  transition: all 0.2s ease-in;
  font-family: 'Raleway', sans-serif;
  color: green;
  font-weight: bold;
  max-width: 550px;
  font-size: 16px;
  text-align: center;
  margin: 10px;

  ${({ rightSolution }) => rightSolution && `
    opacity: 1;
  `}
`;